const track = (eventName, params) => {
    try{
        if(window.fbq) {
            window.fbq('track', eventName, params);
        }
    } catch (e) {
        console.error(e)
    }
}

export default {
    track
}